export const PLANS = {
  STARTER: {
    NAME: 'Starter',
    MONTHLY_PRICE: '1',
    BIANNUAL_PRICE: '1',
    ANNUAL_PRICE: '20',
    DISCOUNT_BIANNUAL: '0',
    DISCOUNT_ANNUAL: '0',
  },
  SMARTER: {
    NAME: 'Smarter',
    MONTHLY_PRICE: '49',
    BIANNUAL_PRICE: '44',
    ANNUAL_PRICE: '39',
    DISCOUNT_BIANNUAL: '10',
    DISCOUNT_ANNUAL: '20',
  },
  PRO: {
    NAME: 'Pro',
    MONTHLY_PRICE: '99',
    BIANNUAL_PRICE: '89',
    ANNUAL_PRICE: '79',
    DISCOUNT_BIANNUAL: '10',
    DISCOUNT_ANNUAL: '20',
  },
  EXPIRED: {
    NAME: 'Expired',
  },
  TRIAL: {
    NAME: 'Trial',
  },
};

export const SUB_USER_PRICES = {
  ANNUAL: 107.89,
  BI_ANNUAL: 56.94,
  MONTHLY: 9,
};

export const plansPricing = (planId: number, cycle: number) => {
  if (planId === 1 && cycle === 1) {
    return PLANS.SMARTER.MONTHLY_PRICE;
  } else if (planId === 1 && cycle === 2) {
    return PLANS.SMARTER.BIANNUAL_PRICE;
  } else if (planId === 1 && cycle === 3) {
    return PLANS.SMARTER.ANNUAL_PRICE;
  } else if (planId === 2 && cycle === 1) {
    return PLANS.PRO.MONTHLY_PRICE;
  } else if (planId === 2 && cycle === 2) {
    return PLANS.PRO.BIANNUAL_PRICE;
  } else if (planId === 2 && cycle === 3) {
    return PLANS.PRO.ANNUAL_PRICE;
  } else if (planId === 4) {
    return PLANS.STARTER.ANNUAL_PRICE;
  }
};

export const selectedPlanName = (planId: number) => {
  if (planId === 1) {
    return PLANS.SMARTER.NAME.toLowerCase();
  } else if (planId === 2) {
    return PLANS.PRO.NAME.toLowerCase();
  } else if (planId === 4) {
    return PLANS.STARTER.NAME.toLowerCase();
  } else if (planId === 0) {
    return PLANS.EXPIRED.NAME.toLowerCase();
  } else if (planId === 999) {
    return PLANS.TRIAL.NAME.toLowerCase();
  }
};
